import type { PlayProposalReview } from '@/types/gtm-agents';

export interface ProposalReviewState extends PlayProposalReview {
  issues?: readonly {
    code: string;
    message: string;
    nodeId?: string | null;
    severity?: 'error' | 'warning';
    blocks?: boolean;
  }[];
}

/** Keep explicit server refusal and legacy errors authoritative in the UI. */
export function proposalIsBlocked(proposal: ProposalReviewState): boolean {
  return (
    proposal.canAccept === false ||
    proposal.buildState === 'blocked' ||
    Boolean(proposal.blockedReasons?.length) ||
    Boolean(
      proposal.issues?.some(
        (issue) => issue.severity === 'error' || issue.blocks === true
      )
    )
  );
}
